import { render, staticRenderFns } from "./CrossbreedingSimulator.vue?vue&type=template&id=90ec8c86&scoped=true"
import script from "./CrossbreedingSimulator.vue?vue&type=script&lang=ts"
export * from "./CrossbreedingSimulator.vue?vue&type=script&lang=ts"
import style0 from "./CrossbreedingSimulator.vue?vue&type=style&index=0&id=90ec8c86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ec8c86",
  null
  
)

export default component.exports